// Author Lin
// Date 2022-01-09 17:35:59

class SithMesInventoryReplacementRepair {
        constructor({
                id = null,
                poItemId = '',
                initiator = '',
                quantity = '',
                requireTakeTime = '',
                actualTakeTime = '',
                takeAwayPerson = '',
                requireReturnTime = '',
                actualReturnTime = '',
                returnPerson = '',
                firstLevelReason = '',
                secondLevelReason = '',
                taskStatus = '',
                attachment = '',
                remark = '',
                attachmentList = ''}
        = {}) {
            this.id = id;
            this.poItemId = poItemId;
            this.initiator = initiator;
            this.quantity = quantity;
            this.requireTakeTime = requireTakeTime;
            this.actualTakeTime = actualTakeTime;
            this.takeAwayPerson = takeAwayPerson;
            this.requireReturnTime = requireReturnTime;
            this.actualReturnTime = actualReturnTime;
            this.returnPerson = returnPerson;
            this.firstLevelReason = firstLevelReason;
            this.secondLevelReason = secondLevelReason;
            this.taskStatus = taskStatus;
            this.attachment = attachment;
            this.remark = remark;
            this.attachmentList = attachmentList;
        }
        }
        
        function newEntity() {
        return new SithMesInventoryReplacementRepair();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'poItemId',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.poItemId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'quantity',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.quantity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'initiatorName',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.initiatorName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'taskStatus',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.taskStatus',
                sortable: true,
                form: {
                type: 'select'
                ,options: [
                        { value: '1', text: '已创建' },
                                    { value: '2', text: '已取走' },
                                    { value: '3', text: '已返回' }
                    ]
                }
                },
                {
                key: 'requireTakeTime',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.requireTakeTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'actualTakeTime',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.actualTakeTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'takeAwayPersonName',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.takeAwayPersonName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'requireReturnTime',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.requireReturnTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'actualReturnTime',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.actualReturnTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'returnPersonName',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.returnPersonName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'firstLevelReason',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.firstLevelReason',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'secondLevelReason',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.secondLevelReason',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'projectCode',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.projectCode',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'projectName',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.projectName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'poNumber',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.poNumber',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'itemCode',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.itemCode',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'materielCode',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.materielCode',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'materielName',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.materielName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'incomingTime',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.incomingTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'receivingDate103',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.receivingDate103',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'inspectionFinishDate105',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.inspectionFinishDate105',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'vendorChnName',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.vendorChnName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'attachmentList',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.attachmentList',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'emAttachment'
                }
                },
                {
                key: 'remark',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            poItemIdFilter : '',
            initiatorFilter : '',
            requireTakeTimeRteFilter : '',
            requireTakeTimeLteFilter : '',
            actualTakeTimeRteFilter : '',
            actualTakeTimeLteFilter : '',
            takeAwayPersonFilter : '',
            requireReturnTimeRteFilter : '',
            requireReturnTimeLteFilter : '',
            actualReturnTimeRteFilter : '',
            actualReturnTimeLteFilter : '',
            returnPersonFilter : '',
            firstLevelReasonFilter : '',
            secondLevelReasonFilter : '',
            taskStatusFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'poItemIdFilter',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.filter.poItemId',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'sithMesInventoryItem'
                    ,correspondingField: 'id'
                        }
                },
                {
                key: 'initiatorFilter',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.filter.initiator',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'id'
                        }
                },
                {
                key: 'requireTakeTimeRteFilter',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.filter.requireTakeTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'requireTakeTimeLteFilter',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.filter.requireTakeTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'actualTakeTimeRteFilter',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.filter.actualTakeTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'actualTakeTimeLteFilter',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.filter.actualTakeTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'takeAwayPersonFilter',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.filter.takeAwayPerson',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'id'
                        }
                },
                {
                key: 'requireReturnTimeRteFilter',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.filter.requireReturnTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'requireReturnTimeLteFilter',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.filter.requireReturnTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'actualReturnTimeRteFilter',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.filter.actualReturnTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'actualReturnTimeLteFilter',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.filter.actualReturnTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'returnPersonFilter',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.filter.returnPerson',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'id'
                        }
                },
                {
                key: 'firstLevelReasonFilter',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.filter.firstLevelReason',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'secondLevelReasonFilter',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.filter.secondLevelReason',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'taskStatusFilter',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.filter.taskStatus',
                disabled: false,
                form: {
                type: 'select'
                    ,showLabelSelectOne: true
                 ,options: [
                        { value: '1', text: '已创建' },
                        { value: '2', text: '已取走' },
                        { value: '3', text: '已返回' }
                    ]
                }
                }
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'poItemId',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.entity.poItemId',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'sithMesInventoryItem'
                    ,correspondingField: 'id'
                        }
                },
                {
                key: 'initiator',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.entity.initiator',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'id'
                        }
                },
                {
                key: 'quantity',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.entity.quantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'requireTakeTime',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.entity.requireTakeTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'actualTakeTime',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.entity.actualTakeTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'takeAwayPerson',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.entity.takeAwayPerson',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'id'
                        }
                },
                {
                key: 'requireReturnTime',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.entity.requireReturnTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'actualReturnTime',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.entity.actualReturnTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'returnPerson',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.entity.returnPerson',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'id'
                        }
                },
                {
                key: 'firstLevelReason',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.entity.firstLevelReason',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'secondLevelReason',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.entity.secondLevelReason',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'taskStatus',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.entity.taskStatus',
                sortable: true,
                disabled: false,
                form: {
                type: 'select'
                    ,showLabelSelectOne: true
                ,options: [
                        { value: '1', text: '已创建' },
                        { value: '2', text: '已取走' },
                        { value: '3', text: '已返回' }
                    ]
                }
                },
                {
                key: 'remark',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                },
                {
                key: 'attachmentList',
                label: 'label.sith.inventory.sithMesInventoryReplacementRepair.entity.attachment',
                sortable: false,
                disabled: false,
                form: {
                type: 'emAttachment'
                    ,correspondingField: 'attachment'
                        }
                }
        ]
        
        export {SithMesInventoryReplacementRepair, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        